
export class SecureHomePage {

    constructor() {

        //document.ready
        $(() => {


        });

    }

}
